import {PaginatedContent} from '../../../../application/contentLoaders/paginatedContent';

class PaginatedUserOffers extends PaginatedContent {
    initListeners() {
        if (this.buttonMore) {
            this.buttonMore.addEventListener('click', (event) => {
                event.preventDefault();
                this.paginate();
            });
        }
    }
}

export {PaginatedUserOffers};
